import { useTranslation } from 'react-i18next'
import 'twin.macro'
import { imageUrl } from '@libs/appUrl'

interface AccountInfoProps {
  user?: {
    img?: string
    name?: string
    mid?: string
  }
}

function AccountInfo({ user: { img, name, mid } = {} }: AccountInfoProps) {
  const { t } = useTranslation('editor')

  const avatarArea = (
    <div tw="h-10 w-10 overflow-hidden rounded-full bg-gray-30 flex-shrink-0">
      {img ? <img src={imageUrl(img)} tw="object-cover" /> : null}
    </div>
  )

  let nameArea = null
  if (name && mid) {
    nameArea = (
      <div tw="flex flex-col">
        <span tw="text-gray-400 text-c2-d leading-c2-d">{t('account.label')}</span>
        <span tw="text-gray-800 text-b1-d leading-b1-d">
          {name}
          <small tw="opacity-75 ml-1">ID {mid}</small>
        </span>
      </div>
    )
  } else if (mid) {
    nameArea = (
      <div tw="flex flex-col">
        <span tw="text-gray-400 text-c2-d leading-c2-d">{t('account.label')}</span>
        <span tw="text-gray-800 text-b1-d leading-b1-d">ID {mid}</span>
      </div>
    )
  }

  return (
    <div tw="flex items-center space-x-4">
      {avatarArea}
      {nameArea}
    </div>
  )
}

export default AccountInfo
